(function () {
  function initSoundFamiliarSliders() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('[data-iw-sound-familiar-slider]').forEach((root) => {
      if (root.dataset.iwSoundFamiliarInitialized === 'true') return;

      const swiperEl = root.querySelector('.iw-sound-familiar__swiper');
      const paginationEl = root.querySelector('.iw-sound-familiar__swiper-pagination');

      if (!swiperEl) return;

      new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 20,
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          990: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      });

      root.dataset.iwSoundFamiliarInitialized = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSoundFamiliarSliders);
  } else {
    initSoundFamiliarSliders();
  }

  document.addEventListener('shopify:section:load', initSoundFamiliarSliders);
})();
